import { createTeam } from './createTeam'
import { getTeams } from './getTeams'
import { getTeamById } from './getTeamById'
import { updateTeam } from './updateTeam'
import { addTeamMember } from './addTeamMember'
import { removeTeamMember } from './removeTeamMember'
import { removeTeam } from './removeTeam'
import { checkCodeIsAvailable } from './checkCodeIsAvailable'
import { getTeamsBySupervisorIds } from './getTeamsBySupervisorIds'

export const teamsService = {
  createTeam,
  getTeams,
  getTeamById,
  updateTeam,
  addTeamMember,
  removeTeamMember,
  removeTeam,
  checkCodeIsAvailable,
  getTeamsBySupervisorIds,
}
